import React, { useEffect, useState } from "react";
import { Grid, Box, CircularProgress } from '@mui/material';
import { BasicCard } from "../../shared/basicCard";
import { useApi } from "../../hooks/useApi";
import { BasicErrorLabel } from "../../shared/basicErrorLabel";
import { updateOrgSeasonNameApi } from "../../api/orgSeasonApi";
import { BasicTextBox } from "../../shared/basicTextBox";
import { useOrgSeasonContext } from "../../context/orgSeasonContext";
import { BasicButton } from "../../shared/basicButton";
import { AdminUser } from "../../api/models/organization";
import { BasicCheckBox } from "../../shared/basicCheckBox";

export interface CreateOrgPanelProps {
    isLoading?: boolean;
    onSubmit: (orgName: string, isPublic:boolean, adminUser?: AdminUser[]) => void;
}   

export function CreateOrgPanel(props: CreateOrgPanelProps): JSX.Element {

    const [newOrgName, setNewOrgName] = useState<string>('');
    const [isPublic, setIsPublic] = useState<boolean>(false);
    const [adminEmail, setAdminEmail] = useState<string>('');
    const [newOrgError, setNewOrgError] = useState<string>('');
    const [adminEmailError, setAdminEmailError] = useState<string>('');


    //update the local value for the name
    function handleAddOrgName(e: React.ChangeEvent<HTMLInputElement>) {
        setNewOrgName(e.target.value);
    }

        //update the local value for the name
    function handleAdminEmail(e: React.ChangeEvent<HTMLInputElement>) {
        setAdminEmail(e.target.value);
    }

    //change the orgSeason name
    async function updateData() {

        if (!newOrgName) {
            setNewOrgError('required');
            return;
        }



        props.onSubmit(newOrgName, isPublic, adminEmail ? [{email:adminEmail, firstName:'', lastName:'' }] : undefined);


    }

    return (<>
        <BasicCard>
                <Box>
                    
                        <Box>
                            <BasicTextBox id='txtOrgName'
                                label='Org Name*'
                                errorMessage={newOrgError}
                                maxLength={20}
                                width={300}
                                value={newOrgName}
                                onChange={handleAddOrgName} />
                        </Box>

                        <Box>
                            <BasicCheckBox label='Public' checked={isPublic} onChange={(e, checked) => setIsPublic(checked)} />
                        </Box>

                        <br/>
                        <Box>
                            <BasicTextBox id='txtAdminEmail'
                                label='Admin Email'
                                errorMessage={adminEmailError}
                                maxLength={50}
                                width={300}
                                value={adminEmail}
                                onChange={handleAdminEmail} />
                        </Box>
                        <br/>
                        <Box>
                           {!props.isLoading &&  <BasicButton onClick={updateData} labelText="Update" />}
                           {props.isLoading && <CircularProgress />}

                        </Box>

                    
                    
                </Box>
            
        </BasicCard>
    </>
    );
}
